import {EntityState} from '@modifi/redux/lib/esm/factories/entity/reducer'
import entityReducer, {OnboardingUserWithoutCompanyView} from './entity'

export default entityReducer

// @ts-expect-error to be fixed
export type UserState = EntityState<OnboardingUserWithoutCompanyView>
